import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"
import '../styles/index.css'

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile.jpeg/" }) {
        childImageSharp {
          fixed(width: 150, height: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
            github
          }
        }
      }
    }
  `)

  const { author } = data.site.siteMetadata
  return (
    <div className="Bio"
      style={{
        backgroundColor: `var(--upper)`,
        color: `var(--textNormal)`,
        transition: `color 0.8s ease-out, background 0.4s ease-out`,
        display: `flex`,
        marginBottom: rhythm(2.5),
        padding: `30px`,
        borderRadius: `10px`,
      }}
    >
      <Image
        fixed={data.avatar.childImageSharp.fixed}
        alt={author.name}
        style={{
          marginRight: rhythm(2 / 2),
          minWidth: 150,
          borderRadius: `50`,
          alignSelf: `center`,
          paddingBottom: `10`
        }}
        imgStyle={{
          borderRadius: `50%`,
        }}
      />
      <p
       style={{ color: "var(--textNormal)" }}
      >
        {author.summary}
        {` `}
        {/* <a target="_blank" href="https://github.com/Uyadav207/Blogs-MDX-website" alt="link">To Contribute to this blog visit this hyperlink.</a> */}
        <div className="socials">
          <p><a target="_blank" rel="noreferrer"  href="https://github.com/Uyadav207/" alt="link"> Github</a></p>
          <p><a target="_blank" rel="noreferrer"  href="https://linkedin.com/in/yadavutkarsh" alt="link"> LinkedIn</a></p>
          <p><a target="_blank" rel="noreferrer"  href="https://utkarshdeveloper.netlify.app/" alt="link"> Website</a></p>
          <p><a target="_blank" rel="noreferrer"  href="https://dev.to/uyadav207" alt="link"> Dev</a></p>
          <p><a target="_blank" rel="noreferrer"  href="https://twitter.com/UYadavDev" alt="link"> Twitter</a></p>
        </div>
      </p>
    </div>
  )
}

export default Bio
